import { NotImplementedError } from "../../../utils/Error";
export class DrawNodeCMDData {
    get node() {
        return this._node;
    }
    set node(value) {
        this._node = value;
    }
    get destShaderData() {
        return this._destShaderData;
    }
    set destShaderData(value) {
        this._destShaderData = value;
    }
    get destSubShader() {
        return this._destSubShader;
    }
    set destSubShader(value) {
        this._destSubShader = value;
    }
    get subMeshIndex() {
        return this._subMeshIndex;
    }
    set subMeshIndex(value) {
        this._subMeshIndex = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class BlitQuadCMDData {
    get element() {
        return this._element;
    }
    set element(value) {
        this._element = value;
    }
    get dest() {
        return this._dest;
    }
    set dest(value) {
        this._dest = value;
    }
    get viewport() {
        return this._viewport;
    }
    set viewport(value) {
        this._viewport = value;
    }
    get scissor() {
        return this._scissor;
    }
    set scissor(value) {
        this._scissor = value;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }
    get offsetScale() {
        return this._offsetScale;
    }
    set offsetScale(value) {
        this._offsetScale = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class DrawElementCMDData {
    setRenderelements(value) {
        throw new NotImplementedError();
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class SetViewportCMD {
    get viewport() {
        return this._viewport;
    }
    set viewport(value) {
        this._viewport = value;
    }
    get scissor() {
        return this._scissor;
    }
    set scissor(value) {
        this._scissor = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
export class SetRenderTargetCMD {
    get rt() {
        return this._rt;
    }
    set rt(value) {
        this._rt = value;
    }
    get clearFlag() {
        return this._clearFlag;
    }
    set clearFlag(value) {
        this._clearFlag = value;
    }
    get clearDepthValue() {
        return this._clearDepthValue;
    }
    set clearDepthValue(value) {
        this._clearDepthValue = value;
    }
    get clearStencilValue() {
        return this._clearStencilValue;
    }
    set clearStencilValue(value) {
        this._clearStencilValue = value;
    }
    get clearColorValue() {
        return this._clearColorValue;
    }
    set clearColorValue(value) {
        this._clearColorValue = value;
    }
    apply(context) {
        throw new NotImplementedError();
    }
}
